export const NOTIFLY_GET_URL = "/notifly/get";
export const NOTIFLY_UPDATE_URL = "/notifly/update";
